module.exports = __webpack_public_path__ + "static/img/steel-beam_256.ee10289.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/steel-beam_256.png
// module id = Al0R
// module chunks = 0